import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

const DefineRolesAndShiftsIntro = ({ pageTitle, pageSubtitle }) => (
  <div className="define-roles-step__intro">
    <Typography
      className="define-roles-step__title text-heading-xl"
      component="h1"
    >
      {pageTitle}
    </Typography>
    <Typography
      className="define-roles-step__subtitle text-body-md"
      component="p"
    >
      {pageSubtitle}
    </Typography>
  </div>
);

DefineRolesAndShiftsIntro.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  pageSubtitle: PropTypes.string.isRequired,
};

export default DefineRolesAndShiftsIntro;
